export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          热门黑料
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20backstage%20of%20a%20concert%20with%20dramatic%20spotlight%2C%20empty%20stage%20with%20microphone%20stand%2C%20warm%20crimson%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20investigative%20mood%2C%20editorial%20photography%2C%20no%20people&width=640&height=400&seq=card-baoliao-01&orientation=landscape"
                alt="某歌手演唱会假唱实锤，现场观众拍到对口型画面"
                title="某歌手演唱会假唱实锤，现场观众拍到对口型画面"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-primary-500 font-medium bg-primary-50 px-2 py-0.5 rounded">明星黑料</span>
              <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug">
                某歌手演唱会假唱实锤，现场观众拍到对口型画面
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                多角度视频曝光，对口型失误被粉丝抓包
              </p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span>3小时前</span>
                <span><i className="ri-eye-line mr-1"></i>28.6万</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20social%20media%20influencer%20studio%20with%20dramatic%20lighting%2C%20empty%20ring%20light%20and%20camera%20setup%2C%20scattered%20products%20on%20floor%2C%20warm%20amber%20tones%2C%20investigative%20documentary%20style%2C%20no%20people&width=640&height=400&seq=card-baoliao-02&orientation=landscape"
                alt="千万粉丝网红被前员工爆料克扣工资、职场霸凌"
                title="千万粉丝网红被前员工爆料克扣工资、职场霸凌"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-primary-500 font-medium bg-primary-50 px-2 py-0.5 rounded">网红黑料</span>
              <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug">
                千万粉丝网红被前员工爆料克扣工资、职场霸凌
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                多名前员工联合发声，晒出聊天记录和欠薪证明
              </p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span>6小时前</span>
                <span><i className="ri-eye-line mr-1"></i>35.2万</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20corporate%20boardroom%20with%20dramatic%20shadows%2C%20empty%20leather%20chairs%20around%20large%20table%2C%20scattered%20documents%2C%20warm%20crimson%20lighting%2C%20noir%20style%2C%20investigative%20mood%2C%20editorial%20photography&width=640&height=400&seq=card-baoliao-03&orientation=landscape"
                alt="某上市公司被曝财务造假，审计机构或遭连带追责"
                title="某上市公司被曝财务造假，审计机构或遭连带追责"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-primary-500 font-medium bg-primary-50 px-2 py-0.5 rounded">商业内幕</span>
              <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug">
                某上市公司被曝财务造假，审计机构或遭连带追责
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                虚增营收超20亿，审计报告存在重大遗漏
              </p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span>9小时前</span>
                <span><i className="ri-eye-line mr-1"></i>19.7万</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20filming%20location%20with%20dramatic%20mood%20lighting%2C%20empty%20movie%20set%20with%20costumes%20on%20rack%2C%20warm%20amber%20and%20deep%20shadows%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20no%20people&width=640&height=400&seq=card-baoliao-04&orientation=landscape"
                alt="某知名导演被曝潜规则女演员，多条聊天记录流出"
                title="某知名导演被曝潜规则女演员，多条聊天记录流出"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-primary-500 font-medium bg-primary-50 px-2 py-0.5 rounded">圈内丑闻</span>
              <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug">
                某知名导演被曝潜规则女演员，多条聊天记录流出
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                受害女演员实名爆料，详细描述潜规则过程
              </p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span>12小时前</span>
                <span><i className="ri-eye-line mr-1"></i>42.1万</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20luxury%20restaurant%20private%20room%20with%20dramatic%20chandelier%20lighting%2C%20empty%20table%20with%20fine%20dining%20setup%2C%20warm%20amber%20and%20crimson%20mood%2C%20noir%20atmosphere%2C%20investigative%20style%2C%20editorial%20photography&width=640&height=400&seq=card-baoliao-05&orientation=landscape"
                alt="某餐饮连锁品牌被曝使用过期食材，后厨画面触目惊心"
                title="某餐饮连锁品牌被曝使用过期食材，后厨画面触目惊心"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-primary-500 font-medium bg-primary-50 px-2 py-0.5 rounded">食品安全</span>
              <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug">
                某餐饮连锁品牌被曝使用过期食材，后厨画面触目惊心
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                内部员工偷拍曝光，过期食材改标签继续使用
              </p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span>15小时前</span>
                <span><i className="ri-eye-line mr-1"></i>56.3万</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20tech%20startup%20office%20with%20dark%20dramatic%20shadows%2C%20empty%20workstations%2C%20liquidation%20notice%20on%20desk%2C%20warm%20amber%20lighting%2C%20investigative%20documentary%20style%2C%20cinematic%20mood%2C%20editorial%20photography&width=640&height=400&seq=card-baoliao-06&orientation=landscape"
                alt="某科技公司创始人卷款跑路，数百员工工资被拖欠"
                title="某科技公司创始人卷款跑路，数百员工工资被拖欠"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-primary-500 font-medium bg-primary-50 px-2 py-0.5 rounded">社会热点</span>
              <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug">
                某科技公司创始人卷款跑路，数百员工工资被拖欠
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                公司账上资金被转移至海外，警方已介入调查
              </p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                <span>18小时前</span>
                <span><i className="ri-eye-line mr-1"></i>63.8万</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}